export default "__VITE_ASSET__BB5yQvyj__"